// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bmA1","label":"styles_label__iU73I"};